/* globals console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    _ = require('lodash'),
    configuration = require('./configuration'),
    tipsAstray = require('./tipsAstray.json'),
    url = configuration.mockdata.tips ? '/mockdata/tips-MN-en.json' : 'https://efw-content.hb101.org/tips-MN-en.json';

module.exports = {
    initialize: function (callback) {
        // console.log('@tips', configuration.tipaudit);
        if (configuration.tipaudit) {
            _.each(tipsAstray.needed, function (value, key) {
                tipsAstray.needed[key] = '✧ ' + value;
            });
        }
        jQuery.getJSON(url, _.bind(function (json) {
            _.extend(this.tips, json, tipsAstray.needed, tipsAstray.typos);
            if (callback) { callback(null); }
        }, this));
    },
    tips: {}
};
